/* Scope & Field product page helpers. Loaded deferred from snippets/sf-sticky-atc.liquid.
   1. Sticky add-to-basket bar: shows once the main Add to basket button has scrolled above the
      viewport (checked on scroll), and its button presses the main one so the variant and kit
      add-ons go with it.
   2. Keeps the stock line, the Pre-order and Out of stock button wording, and the bar's price and button
      in step when the variant changes. */
(function () {
  class SfStickyAtc extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.main = document.getElementById(`ProductSubmitButton-${this.section}`);
      this.button = this.querySelector('.sf-sticky-atc__button');
      if (!this.main || !this.button) return;
      this.hidden = false;
      this.button.addEventListener('click', () => {
        if (this.main.disabled) return;
        this.main.click();
      });
      this.check = this.check.bind(this);
      window.addEventListener('scroll', this.check, { passive: true });
      window.addEventListener('resize', this.check, { passive: true });
      this.check();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.check);
      window.removeEventListener('resize', this.check);
      document.body.classList.remove('sf-has-sticky-atc');
    }
    check() {
      const above = this.main.getBoundingClientRect().bottom < 0;
      if (above === this.visible) return;
      this.visible = above;
      this.classList.toggle('is-visible', above);
      document.body.classList.toggle('sf-has-sticky-atc', above);
    }
    sync(html) {
      const price = html.getElementById(`SfStickyPrice-${this.section}`);
      const target = this.querySelector(`#SfStickyPrice-${this.section}`);
      if (price && target) target.innerHTML = price.innerHTML;
      const sourceButton = html.querySelector('.sf-sticky-atc__button');
      if (sourceButton) {
        this.button.disabled = sourceButton.disabled;
        this.button.textContent = sourceButton.textContent.trim();
      }
    }
  }
  if (!customElements.get('sf-sticky-atc')) customElements.define('sf-sticky-atc', SfStickyAtc);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const { sectionId, html } = event.data || {};
      if (!sectionId || !html) return;
      const stock = document.getElementById(`SfStock-${sectionId}`);
      const newStock = html.getElementById(`SfStock-${sectionId}`);
      if (stock && newStock) stock.innerHTML = newStock.innerHTML;
      // Dawn relabels the button from the variant alone; keep the Pre-order and Out of stock wording and state
      const button = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const newButton = html.getElementById(`ProductSubmitButton-${sectionId}`);
      if (button && newButton && newButton.dataset.sfState) {
        setTimeout(() => {
          const label = button.querySelector('span');
          if (label) label.textContent = newButton.textContent.trim();
          button.disabled = newButton.hasAttribute('disabled');
        }, 0);
      }
      document.querySelectorAll(`sf-sticky-atc[data-section="${sectionId}"]`).forEach((bar) => bar.sync(html));
    });
  }
})();
